import DiffusionSession from 'rp-diffusion-connector';
import jQuery from 'jquery';

/**
 * @name results.controller:FastResultTrigger
 * @description
 * # FastResultTrigger
 * Perform get AJAX request for races id pairs.
 * Check response and broadcast appropriate events
 * or repeat a request.
 * If flag for continue requesting ids for fast result is set in true - repeat
 * AJAX request every minute
 */
export default function ($scope, $element, $timeout, $http, $rootScope, config) {
    'ngInject';

    /**
     * Variables for directive
     *
     * @type {string} Date of the race
     * @type {string} Name of the tab from which will be performed AJAX request
     */
    $scope.date = $element.data('date');
    $scope.tab = $element.data('tab');
    $scope.parseResultsMessage = records => records
        .map(([record]) => record)
        .filter(record => record.includes('<h1>'))
        .map((record) => {
            const parsed = record.split(/<\/?b>/).map(i => i.trim());
            return {
                outcome_code: parsed[1],
                saddle_cloth: parsed[2].replace('(', '').replace(')', ''),
                horse_name: parsed[3],
                price: parsed[4].replace('<h1>', ''),
            };
        });

    const getDiffusionAttributes = (meetingElement) => {
        const $meetingElement = jQuery(meetingElement).parent().parent();
        const racedateAttr = 'data-diffusion-racedate';
        return {
            raceDate: $meetingElement.closest(`[${racedateAttr}]`).data('diffusionRacedate'),
            raceTime: $meetingElement.data('diffusionRacetime'),
            courseName: $meetingElement.data('diffusionCoursename'),
            raceId: $meetingElement.data('diffusionRaceId'),
            crsId: $meetingElement.data('crsId'),
        };
    };

    $scope.onDataReceive = (WebClientMessage) => {
        const records = WebClientMessage.getRecords();
        const topic = WebClientMessage.getTopic();
        const [, raceDate, courseName, raceTime] = topic.split('/');
        const isFullResult = records.some(record => ((/<b>\d+ ran<\/b>/).test(record[0])));
        if (isFullResult) {
            $scope.session.unsubscribe(topic);
        }
        const fastResult = $scope.parseResultsMessage(records);
        const meetingResult = $element.find('[data-directive-apply-fast-result]').toArray()
            .map(getDiffusionAttributes)
            .find(meeting => meeting.raceDate === raceDate
                && meeting.raceTime === raceTime
                && meeting.courseName === courseName);
        if (meetingResult) {
            $rootScope.$broadcast(`setFastResults[${meetingResult.raceId}]`, fastResult);
        }
    };
    $scope.session = new DiffusionSession({
        onDataFunction: $scope.onDataReceive,
    });
    const topics = $element.find('[data-directive-apply-fast-result]')
        .parent().parent()
        .toArray()
        .map(raceElement => [
            'HORSES',
            $scope.date,
            raceElement.dataset.diffusionCoursename,
            raceElement.dataset.diffusionRacetime,
            'RESULTSTEXT',
        ].join('/'));
    $scope.session.subscribe({ topics });
    const hash = $element.data('blabla');

    /**
     * Form list of events with appropriate data and broadcast them
     *
     * @param {array} data Array of objects with race's ids pair (fastRaceId/raceId)
     */
    $scope.broadcastEvents = (data) => {
        let event;
        let raceData = {};
        for (let i = 0, len = data.length; i < len; i++) {
            event = `get${data[i].fullResultAvailable ? 'Full' : 'Fast'}Results[${data[i].raceId}]`;

            raceData = {
                fastRaceId: data[i].fastRaceId,
                raceId: data[i].raceId,
                date: $scope.date,
                tab: $scope.tab
            };

            $rootScope.$broadcast(event, raceData);
        }
    };

    /**
     * Set timeout with specific callback and time from param
     * @param {number} time Timeout value
     */
    $scope.setTimeout = (time) => {
        $timeout($scope.getData, time);
    };

    /**
     * Make AJAX get request to check for races which have fast race id.
     * On success check if response is object and call
     * $scope.broadcastEvents, if not will repeat AJAX request, also response
     * has flag to know should we continue to
     * perform AJAX requests.
     */
    $scope.getData = () => {
        const url = `${config.get('resultsPath')}/data/${$scope.date}/${hash}.json`;

        $http.get(url).success((data) => {
            if (typeof data === 'object') {
                if (data.data) {
                    $scope.broadcastEvents(data.data);
                }
            } else {
                if (data.continue) {
                    $scope.getData();
                }
            }

            if (data.continue) {
                $scope.setTimeout(30000);
            }
        }).error(() => {
            $scope.setTimeout(30000);
        });
    };

    $scope.getData();
}



// WEBPACK FOOTER //
// ./src/js/controllers/directiveFastResultTrigger.js